import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../auth/AuthContext";
import { toast } from "sonner";
import ImageUploader from "./ImageUploader";
import { parkingPatchPayload } from "../lib/parkingImages";

/** Inline photo re-upload for an existing parking spot (PATCH /parking/{id}). */
export default function ParkingSpotPhotoEditor({ spot, onSaved, onClose }) {
  const [images, setImages] = useState(spot?.images || []);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setImages(spot?.images || []);
  }, [spot?.spot_id, spot?.images]);

  const save = async () => {
    if (!images.length) {
      toast.error("Add at least one photo");
      return;
    }
    setSaving(true);
    try {
      const payload = parkingPatchPayload(spot, images);
      const r = await axios.patch(`${API}/parking/${spot.spot_id}`, payload, { withCredentials: true });
      toast.success("Photos updated");
      onSaved?.(r.data);
      onClose?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save photos");
    } finally {
      setSaving(false);
    }
  };

  if (!spot) return null;

  return (
    <div className="p-4 border-t border-[var(--zc-border)] bg-[var(--zc-bg-2)]" data-testid={`parking-photo-editor-${spot.spot_id}`}>
      <div className="eyebrow mb-2">Add photos</div>
      <p className="text-xs text-[var(--zc-text-3)] mb-3">
        Upload clear shots of your parking spot so renters know what to expect.
      </p>
      <ImageUploader value={images} onChange={setImages} max={4} testid={`parking-photo-editor-uploader-${spot.spot_id}`} />
      <div className="flex gap-2 mt-4">
        <button
          type="button"
          onClick={save}
          disabled={saving || !images.length}
          className="px-4 h-9 zc-btn-primary text-xs disabled:opacity-60"
          data-testid={`parking-photo-editor-save-${spot.spot_id}`}
        >
          {saving ? "Saving…" : "Save photos"}
        </button>
        {onClose && (
          <button type="button" onClick={onClose} className="px-4 h-9 zc-btn-ghost text-xs">
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}
